<!-- 全部商品的多选全选 -->
<template>
  <div class="groups">
    <div class="all">
      <el-checkbox
        :indeterminate="mallIsIndeterminate"
        v-model="mallCheckAll"
        @change="handleCheckAllChange"
        >全选</el-checkbox
      >
    </div>
    <div class="marginT">
      <div v-if="goods.length == 0" class="color">暂无数据</div>
      <el-checkbox-group v-model="checks" @change="handleCheckedCitiesChange">
        <el-checkbox
          v-for="(item, index) in goods"
          :label="item.id"
          :key="index"
          >{{ item.name || item.title }}</el-checkbox
        >
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
// 全选
// 全选
// 全选
// 全选公共方法
// 全选公共方法
// 全选公共方法
import { goodsList } from "@/api/vip";
import { getComList } from "@/api/mall";
import { productList } from "@/api/integralMall";
import { storeServeList } from "@/api/storeManage";
import { mapGetters } from "vuex";
export default {
  props: {
    jude: {
      type: Number,
      default: 0
    },
    alone: {
      type: Number,
      default: 0 //当为1的时候数据来自父级，子级不调取数据
    },
    Datas: {
      type: Array,
      default: () => {
        return [];
      }
    },
    editDatas: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      goods: [], //数据
      mallIsIndeterminate: false,
      mallCheckAll: false,
      checks: this.editDatas
    };
  },
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  methods: {
    //
    handleCheckAllChange(val) {
      var arr = this.goods;
      var newAll = [];
      arr.forEach(item => {
        newAll.push(item.id);
      });
      this.checks = val ? newAll : [];
      this.mallIsIndeterminate = false;
      // 传递给父级
      this.$emit("checkedGoods", this.checks);
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.mallCheckAll = checkedCount === this.goods.length;
      // this.mallIsIndeterminate =
      //   checkedCount > 0 && checkedCount < this.goods.length;
      // 传递给父级
      this.$emit("checkedGoods", this.checks);
    },
    //部分商品
    getSomeProduct() {
      // 默认商城商品 0
      // jude 00 由父级传过来数据不调取接口
      // jude 0 为商城
      // jude 3 为油品
      let data = {
        token: this.token,
        app_id: this.app_id
      };
      if (this.jude == 0) {
        getComList(data).then(res => {
          this.goods = res.data;
          // this.mallIsIndeterminate = this.editDatas.length < this.goods.length;
          // (this.mallCheckAll = true),
          this.mallCheckAll =
            this.editDatas.length == this.goods.length &&
            this.goods.length != 0;
          console.log(
            "11列表",
            this.goods,
            this.jude,
            this.mallIsIndeterminate,
            this.mallCheckAll
          );
        });
      } else if (this.jude == 1) {
        //选择油品
        productList(data).then(res => {
          console.log("积分", res);
          this.goods = res.data.result;
          // this.mallIsIndeterminate = this.editDatas.length < this.goods.length;
          let i = 0;
          for (i in this.goods) {
            this.goods[i].name = this.goods[i].title;
          }
          this.mallCheckAll =
            this.editDatas.length == this.goods.length &&
            this.goods.length != 0;
          console.log(
            "jifen列表",
            this.goods,
            this.jude,
            this.mallIsIndeterminate,
            this.mallCheckAll,
            this.checks
          );
        });
      } else if (this.jude == 3) {
        //选择油品
        goodsList(data).then(res => {
          this.goods = res.data;
          // this.mallIsIndeterminate = this.editDatas.length < this.goods.length;
          // (this.mallCheckAll = true),
          this.mallCheckAll =
            this.editDatas.length == this.goods.length &&
            this.goods.length != 0;
          console.log(
            "you列表",
            this.goods,
            this.jude,
            this.mallIsIndeterminate,
            this.mallCheckAll,
            this.checks
          );
        });
      } else if (this.jude == 4) {
        //选择门店服务
        storeServeList(data).then(res => {
          this.goods = res.data;
          // this.mallIsIndeterminate = this.editDatas.length < this.goods.length;
          // (this.mallCheckAll = true),
          this.mallCheckAll =
            this.editDatas.length == this.goods.length &&
            this.goods.length != 0;
          console.log(
            "服务列表",
            this.goods,
            this.jude,
            this.mallIsIndeterminate,
            this.mallCheckAll,
            this.checks
          );
        });
      }
    }
  },
  mounted() {
    if (this.alone == 1) {
      // 需从父组件传递过来值，及控制全选的状态参数也要更改
    } else {
      setTimeout(this.getSomeProduct(), 0);
    }
    //
  }
};
</script>
<style lang="scss" scoped>
.color {
  color: #ccc;
}
</style>
